import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { TextInput } from "@/components/site/Field";
import { api, errMsg } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await api.post("/auth/login", { email, password });
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <section className="grid-bg flex min-h-[70vh] items-center justify-center px-4 py-20">
      <form onSubmit={submit} className="card-tech w-full max-w-md space-y-5 p-8" data-testid="admin-login-form">
        <Lock className="h-8 w-8 text-red-500" />
        <div>
          <p className="eyebrow">Área do prestador</p>
          <h1 className="mt-2 text-3xl font-bold uppercase text-white">Acesso restrito</h1>
        </div>
        <TextInput label="E-mail" type="email" required value={email} onChange={setEmail} testid="admin-login-email" autoComplete="username" />
        <TextInput label="Senha" type="password" required value={password} onChange={setPassword} testid="admin-login-password" autoComplete="current-password" />
        {err && <p className="text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} className="btn-red w-full" data-testid="admin-login-submit">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Entrar</button>
      </form>
    </section>
  );
}
